import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Container, Row, Col, Card } from "react-bootstrap";

import NsdlPanCardService from "../../../services/NsdlPanCardService";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import SideBar from "../../../components/Sidebar";

const NsdlReceipt = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchReceipt();
  }, []);

  const fetchReceipt = async () => {
    try {
      setLoading(true);

      // Get encrypted_data from URL query
      const queryParams = new URLSearchParams(window.location.search);
      let encryptedData = queryParams.get("encrypted_data");

      if (!encryptedData) {
        Swal.fire("Oops!", "Encrypted data not found in URL", "error");
        setLoading(false);
        return;
      }

      // Replace spaces with '+' if any (common URL issue)
      encryptedData = encryptedData.replace(/ /g, "+");

      // Call service with encrypted data
      const result = await NsdlPanCardService.nsdlResponse(encryptedData);

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Transaction failed", "error");
        setLoading(false);
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        setData(responseData.data);
      } else {
        Swal.fire(
          "Oops!",
          responseData.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="mt-3">
      {loading && <LoadingScreen />}

      <Row>
        {/* Sidebar */}

        <SideBar />

        {/* Main Content */}
        <Col md={9}>
          <Card className="shadow-sm mb-4">
            <Card.Body>
              <h4 className="mb-4 text-center">Receipt</h4>
              {data ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <tbody>
                      <tr>
                        <td>STATUS</td>
                        <td>:</td>
                        <td>{data.status}</td>
                      </tr>
                      <tr>
                        <td>RESPONSE</td>
                        <td>:</td>
                        <td>{data.error_message || "-"}</td>
                      </tr>
                      <tr>
                        <td>ORDER ID</td>
                        <td>:</td>
                        <td>{data.order_id}</td>
                      </tr>
                      <tr>
                        <td>ACKNOWLEDGEMENT NO</td>
                        <td>:</td>
                        <td>{data.ack_no}</td>
                      </tr>
                      <tr>
                        <td>AMOUNT</td>
                        <td>:</td>
                        <td>{data.amount}</td>
                      </tr>
                      <tr>
                        <td>TIMESTAMP</td>
                        <td>:</td>
                        <td>{data.date}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="text-center mt-4 mb-3">
                    <b className="text-danger">
                      If your PAN application is not completed or unsuccessful,
                      the amount paid will be automatically refunded within 4
                      hours.
                    </b>
                  </div>

                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => (window.location.href = "/")}
                    >
                      Back to Dashboard
                    </button>
                  </div>
                </div>
              ) : !loading ? (
                <div className="text-center text-muted">
                  No receipt data available.
                </div>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NsdlReceipt;
